<script>
  import ChoiceInput from './choice-input.svelte';

  export let value;

  export let onChange = () => {};

  // TODO temporary 'none' icon, need to find appropriate one:
  const options = [
    { value: 'left', icon: 'arrow-left-to-line' },
    { value: 'none', icon: 'fold-vertical' },
    { value: 'right', icon: 'arrow-right-to-line' }
  ];
</script>

<ChoiceInput {value} {options} {onChange} />
